import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-l-small', 'LetterLSmall', [["path",{"d":"M10 8v8h4","key":"svg-0"}]]);